import { BUCKET_BY_TYPES, EXPERIMENT_PROJECTS } from '@lusha-growth/experiment-react-sdk';
const FLAGS = {
    // PLUGIN_BULK_FILTERS_TEST: {
    //   key: 'plugin_bulk_filters_test',
    //   project: EXPERIMENT_PROJECTS.PLUGIN,
    //   bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
    //   variations: {
    //     CONTROL: 'control_filters',
    //     TEST: 'test_bulk_dropdown_filters',
    //   },
    // },
    PLUGIN_ON_DEMAND_CONTACTS: {
        key: 'on_demand_test',
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        variations: {
            CONTROL: 'on_demand_control_variant',
            TEST: 'on_demand_test_variant',
        },
    },
    AI_ASSISTANT: {
        enabled: true,
        preload: { enrolledOnly: true },
        project: EXPERIMENT_PROJECTS.MAIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'ai_assistant_m2',
        variations: {
            TEST: 'test_homepage_with_assistant',
            CONTROL: 'control_homepage_with_search',
        },
    },
};
const FLAG_SETTINGS = [
    // {
    //   key: FLAGS.PLUGIN_BULK_FILTERS_TEST.key,
    //   project: EXPERIMENT_PROJECTS.PLUGIN,
    //   preload: { disableImpression: true },
    //   enabled: true,
    //   bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
    // },
    {
        key: FLAGS.PLUGIN_ON_DEMAND_CONTACTS.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
    {
        key: FLAGS.AI_ASSISTANT.key,
        project: EXPERIMENT_PROJECTS.MAIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: true,
    },
];
export { FLAG_SETTINGS, FLAGS };
